import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";

const ConfirmModal = ({ isOpen, toggle, title, message, onConfirm }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} scrollable centered fade={true}>
      <ModalHeader toggle={toggle} style={{ background: "#E0F8E0" }}>
        {title || "Confirm"}{" "}
      </ModalHeader>
      <ModalBody>{message || "Are you sure?"}</ModalBody>
      <ModalFooter>
        <Button color="secondary" className="btn-sm" onClick={toggle}>
          Cancel
        </Button>
        <Button
          className="btn-sm"
          color="danger"
          onClick={() => {
            onConfirm();
            toggle();
          }}
        >
          Confirm
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ConfirmModal;
